<button (click)="handleClick()" type="button" class="dropdown-item">
    <i [ngClass]="icon"></i>
    {{ label }}
</button>